import { Col, Form, Input, Modal, Radio, Row, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import lang from "../../../helper/langHelper";
import { Severty, ShowToast } from "../../../helper/toast";
import useRequest from "../../../hooks/useRequest";

const AddForm = ({ api, show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        title: data.title,
        description: data.description,
        status: data.status || "active",
      });
      setFileList([]);
    } else {
      form.resetFields();
      setFileList([]);
    }
  }, [data, form]);

  const onCreate = (values) => {
    const selectedFile = fileList?.[0]?.originFileObj;
    if (!data && !selectedFile) {
      ShowToast("Please upload a PDF document", Severty.ERROR);
      return;
    }

    setLoading(true);
    const payload = new FormData();
    payload.append("title", values.title || "");
    payload.append("description", values.description || "");
    payload.append("status", values.status || "active");
    if (selectedFile) payload.append("file", selectedFile);

    request({
      url: data ? `${api.addEdit}/${data._id}` : api.addEdit,
      method: data ? "PUT" : "POST",
      data: payload,
      header: { "Content-Type": "multipart/form-data" },
      onSuccess: (response) => {
        setLoading(false);
        if (response.status) {
          ShowToast(response.message, Severty.SUCCESS);
          hide();
          refresh();
        } else {
          ShowToast(response.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error?.response?.data?.message || error?.message || "Something went wrong", Severty.ERROR);
      },
    });
  };

  return (
    <Modal
      open={show}
      width={760}
      okText={data ? lang("Update") : lang("Add")}
      cancelText={lang("Cancel")}
      onCancel={hide}
      okButtonProps={{ form: "digital-document-form", htmlType: "submit", loading }}
      centered
      className="tab_modal"
    >
      <Form id="digital-document-form" form={form} onFinish={onCreate} layout="vertical" initialValues={{ status: "active" }}>
        <h4 className="modal_title_cls">{data ? "Edit Digital Document" : "Add Digital Document"}</h4>
        <Row gutter={[16, 0]}>
          <Col span={24} md={12}>
            <Form.Item label="Title" name="title" rules={[{ required: true, message: "Title is required" }]}>
              <Input autoComplete="off" placeholder="Enter title" />
            </Form.Item>
          </Col>
          <Col span={24} md={12}>
            <Form.Item label="Status" name="status">
              <Radio.Group>
                <Radio value="active">Active</Radio>
                <Radio value="inactive">Inactive</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="Description" name="description">
              <Input.TextArea rows={4} placeholder="Enter description" />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label={data ? `PDF Document${data.file_name ? ` (${data.file_name})` : ""}` : "PDF Document"}>
              <Upload
                accept="application/pdf,.pdf"
                maxCount={1}
                beforeUpload={() => false}
                fileList={fileList}
                onChange={({ fileList: nextFileList }) => setFileList(nextFileList)}
              >
                <button type="button" className="ant-btn">
                  <UploadOutlined /> Upload PDF
                </button>
              </Upload>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default AddForm;
